import React from 'react'
import PropTypes from 'prop-types'

const Row = (props) => {
  return (
    <div className="row">{props.children}</div>
  )
}

const Col = (props) => {
  return (
    <div className={props.width ? `col-${props.width}` : 'col' }>
      {props.children}
    </div>
  )
}

const Label = (props) => {
  return (
    <label htmlFor={props.htmlFor} className="form-label">{props.children}</label>
  )
}

const Input = (props) => {
  return (
    <input
      className="form-control"
      {...props}
      ></input>
  )
}
Input.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func
}

Input.defaultProps = {
  type: "string",
  onChange: function(){}
}
export { Row, Col, Label, Input}
